// extracted by mini-css-extract-plugin
export var noSpinners = "_o4-6";
export var percentageInput = "_o4-7";
export var variantColor1 = "_o4-0";
export var variantColor2 = "_o4-1";
export var variantColor3 = "_o4-2";
export var variantColor4 = "_o4-3";
export var variantColor5 = "_o4-4";
export var variantColor6 = "_o4-5";